import React from 'react';

const AsyncKeywordClientList = React.lazy(() => import('./KeywordClientListContainer'));

export const KeywordClientList = () => {
  return <AsyncKeywordClientList />;
};
